import { Component } from '@angular/core';

@Component({
  selector: 'app-property-lease-portal',
  templateUrl: './property-lease-portal.component.html',
  standalone: false,
})
export class PropertyLeasePortalComponent {}
